module.exports = __webpack_public_path__ + "static/fipcwhitelambs3-87891864e0904121744a8fb90a91cdef.jpeg";